import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "node" })
], -1)
const _hoisted_2 = { class: "" }

import { toRefs, useSlots } from 'vue'
import type { PropType } from 'vue'

export type TSlotDefaultParam<TData> = {
  data: TData
  index: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Logger',
  props: {
  items: {
    type: Array as PropType<any[]>,
    default: () => [],
    required: true
  }
},
  setup(__props) {

const props = __props



const slot = useSlots()
const { items } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (data, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "timeline pb-5"
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ data, index })))
        ])
      ]))
    }), 128))
  ]))
}
}

})